import { NgModule } from '@angular/core';
import { FactoryNodeInterfaceConfigToStringPipe } from './factory-node-interface-config-to-string.pipe';


@NgModule({
    imports: [],
    exports: [FactoryNodeInterfaceConfigToStringPipe],
    declarations: [FactoryNodeInterfaceConfigToStringPipe],
    providers: [],
})
export class FactoryNodeInterfaceConfigToStringPipeModule { }
